import { Tool } from './base';

export class SentinelOneSingularityTool extends Tool {
  public readonly toolName = 'SentinelOne Singularity';

  public generateSearchPermalink(
    rootURL: string,
    renderedContent: string,
  ): string {
    const encodedRenderedContent = encodeURIComponent(renderedContent);
    return `${rootURL}/events?view=xdr&filter=${encodedRenderedContent}&startTime=24+hours`;
  }
}
